(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["co-cart-cross-sell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',async event=>{
 const form=event.target.closest('[data-co-cross]');if(!form)return;
 event.preventDefault();const button=form.querySelector('button');const error=form.querySelector('[role="alert"]');button.disabled=true;error.hidden=true;
 try{const data=new FormData(form);data.append('quantity','1');data.append('sections','cart-drawer,cart-icon-bubble');data.append('sections_url',location.pathname);const response=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw Error(result.description||'');const drawer=document.querySelector('cart-drawer');if(drawer&&result.sections){drawer.renderContents(result);drawer.classList.remove('is-empty');}else{location.href=(window.Shopify?.routes?.root||'/')+'cart';}}catch(e){error.hidden=false;button.disabled=false;}
});
  } catch(e) { console.error(e); }
})();

})();
